import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 1%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const ContractContainer = styled.div`
  box-sizing: border-box;
  width: 90%;
  padding: 20px;
  background: white;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  /* border-radius: 5px; */
  height: 50vh;
  overflow-y: scroll;
`;

export const TacContainer = styled.div`
  box-sizing: border-box;
  display: flex;

  margin: 1.5rem;
  /* border: 3px solid #ddd; */
  /* background-color: white; */
  width: 90%;
  /* border-radius: 5px; */
`;
